let generateId

/**
 * Fallback version (generateId)
 */
if (typeof crypto === 'undefined') {
  // For Jest tests
  generateId = (prefix = 'id_') => {
    return generateShortId(prefix)
  }
} else {
  // For browsers
  generateId = (prefix = 'id_') => {
    return (
      (prefix || '') +
      ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      )
    )
  }
}

/**
 * Wrap unique id generator
 * @param {String} prefix
 * @returns
 */
export function generateShortId(prefix = 'id_') {
  return (prefix || '') + generateUUID()
}

/**
 * @todo Internal, use generateUUID instead
 * @param {*} prefix
 * @returns
 */
export function uuidv4(prefix = 'id_') {
  return generateId(prefix)
}

export function uniqueIdFromString(str) {
  return window.btoa(str.replace(/\s/g, '').replace(/\n/g, '')).slice(0, 10)
}

/**
 * @public
 * @param {*} prefix
 * @returns
 */
export function generateUUID(prefix = '') {
  try {
    const hexChars = '0123456789abcdef'

    const getRandomHexChar = () => hexChars[Math.floor(Math.random() * 16)]

    const generateRandomHex = (length) =>
      Array.from({ length }, getRandomHexChar).join('')

    const formatUUID = (uuid) =>
      `${uuid.substr(0, 8)}-${uuid.substr(8, 4)}-4${uuid.substr(
        13,
        3
      )}-${uuid.substr(16, 4)}-${uuid.substr(20, 12)}`

    const firstPart = generateRandomHex(8)
    const secondPart = generateRandomHex(4)
    const thirdPart = generateRandomHex(3)
    const fourthPart = '8' + generateRandomHex(3)
    const fifthPart = generateRandomHex(12)

    const uuid = formatUUID(
      `${firstPart}${secondPart}${thirdPart}${fourthPart}${fifthPart}`
    )
    return prefix + uuid
  } catch (err) {
    console.error(err)
    return uuidv4(prefix)
  }
}
